import { acquireAccessToken } from '../msal';
import api from './api';
import appConfig from '../AppConfig';

const postStream = async <TData>(params: { url: string; data: TData; onMessage: (msg: string) => void; onError: (err: any) => void; signal?: AbortSignal }) => {
    try {
        const accessToken = await acquireAccessToken({ scopes: appConfig.azureAd.accessScopes });
        const response = await fetch(`${appConfig.apiBaseUrl}/${params.url}`, {
            signal: params.signal,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify(params.data),
        });

        if (!response.body) {
            throw new Error('No response body');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let done = false;
        while (!done) {
            const { value, done: doneReading } = await reader.read();
            done = doneReading;
            if (done) {
                break;
            }
            if (value) {
                const decodedMessages = decoder.decode(value, { stream: true });
                params.onMessage(decodedMessages);
            }
        }
    } catch (error) {
        params.onError(error);
    }
};

const post = async <TResponse = any, TData = any>(params: {
        url: string;
        data?: TData;
        signal?: AbortSignal;
}) => {
    const response = await api.post<TResponse>(params.url, params.data, { signal: params.signal });
    return response.data;
}

const get = async <TData>(params: { url: string; signal?: AbortSignal }) => {
    const response = await api.get<TData>(params.url, { signal: params.signal });
    return response.data;
}

const deleteRequest = async (params: { url: string; signal?: AbortSignal }) => {
    await api.delete(params.url, { signal: params.signal });
}

const patch = async <TResponse = any, TData = any>(params: {
    url: string;
    data: TData | undefined;
    signal?: AbortSignal;
}) => {
    const response = await api.patch<TResponse>(params.url, params.data, { signal: params.signal });
    return response.data;
}

const ApiService = { postStream, post, get, delete: deleteRequest, patch };

export default ApiService;